module.exports = __webpack_public_path__ + "img/twitter.55ae84ea.svg";